import { subscribeChannel, publishChannel } from './channelUtils';

export function sendClients(clientes) {
    
    publishChannel('clientes-sync', clientes);

}

export function sendClientUpsert(cliente) {
    
    publishChannel('cliente-upsert', cliente);

}

export function sendClientRemove(clienteId) {
    
    publishChannel('cliente-remove', clienteId);

}

export function sendClientsSelected(selected) {
    
    publishChannel('clientes-selected', selected);

}

export function listenClients(callback) {

    return subscribeChannel((event) => {

        const { tipo, payload } = event.data;

        if (
            tipo !== 'clientes-sync' &&
            tipo !== 'cliente-upsert' &&
            tipo !== 'cliente-remove' &&
            tipo !== 'clientes-selected'
        ) {
            return;
        }

        callback({ tipo, payload });

    });

}